import { defaultLocale, locales } from './localeUtils';
export { defaultLocale, locales };
//# sourceMappingURL=index.js.map